// Subscription status names
enum SubscriptionStatusNames {
  Trial = 'Trial',
  Active = 'Active',
  Inactive = 'Inactive',
}

export { SubscriptionStatusNames };
